import { useEffect, useState } from "react"
import { useForm } from "react-hook-form"
import { RenderForm } from "../../jsonSchemaForm/formRenderer"

const _cProps = {
    error: {},
    fields: [],
    setData: (val) => { },
    defaultValue: {},
    formFields: [],
    backgroundColor: '',
    childFormRef: {}
}
export function ChildFieldForm(props = _cProps) {
    const form = useForm()
    const { register, unregister, formState: { errors, isValid }, getValues } = form
    const [isRegistered, setIsRegistered] = useState(false)

    useEffect(() => {
        if(typeof props?.childFormRef == "function")
        props?.childFormRef(form)
    },[])

    useEffect(() => {
        form.handleSubmit(() => { })()
    }, [props.error])


    useEffect(() => {
        props.fields.map(x => register(x, {
            value: props.defaultValue[x], onChange: (e) => {
                const val = getValues() || {};
                props.setData({ ...val, [x]: e.target.value },  form.formState.errors)
            }
        }))
        setIsRegistered(true)
        return () => {
            props.fields.map(x => unregister(x))
            setIsRegistered(false)
        }
    }, [])

    const fieldsConfig = props.formFields

    return <div style={{ background: props.backgroundColor || 'transparent' }}>
        {isRegistered && <RenderForm form={form} fields={fieldsConfig} inputForm = {props.inputForm}/>}
    </div>
}